module.exports = __webpack_public_path__ + "img/Easy Read_png.ceeda482.png";